<template>
  <v-text-field
    :label="required ? `${label}*`: label"
    v-model="valor"
    :hint="hintText"
    persistent-hint
    :error-messages="errorMessages"
    :required="required"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    :name="name"
    :disabled="disabled"
    :readonly="readonly"
    v-bind="extraOpt"
    :rules="[rules.number]"
  ></v-text-field>
</template>

<script>
import fieldMixin from "./mixins/fieldMixin";

export default {
  name: "NumberField",
  mixins: [fieldMixin],
  data: () => ({
    valor: null,
    rules: {
      number: value => {
        const pattern = /^[+-]?\d+(\.\d+)?$/
         if (!isNaN(value)) {
          if (Number(value) > 0) {
            return true;
          } else {
            return 'Número inválido.'
          }
        } else {
          return 'Número inválido.'
        }

        //return pattern.test(value) || 'Número inválido.'
      },
    },
  }),
  mounted() {
    this.valor = this.value;
  },
  watch: {
    value(val) {
      this.valor = val;
    },
  },
}
</script>

<style scoped>

</style>
